import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/RSTheme";

import DashboardIcon from "@mui/icons-material/Dashboard";
import ScheduletIcon from "@mui/icons-material/Schedule";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const RSMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/rs/",
            label: "Dashboard",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Rostering menu"
            data-cy="menu_rs"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <ScheduletIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Rostering" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems.map(({ path, icon, label }) => (
                        <ListItem
                            key={path}
                            component={Link}
                            to={path}
                            disablePadding
                        >
                            <ListItemButton className="nested">
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText>{label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </List>
    );
};

export default RSMenu;
